/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IRentPaymentData
  extends Array<{
    id: number;
    header: string;
    subHeader?: string;
    valuesHeader?: string;
    values: {
      valueId: number;
      name: string;
      value: string;
    }[];
  }> {}

interface IRentReviewPayload {
  id: string;
  modalType: 'tableReview' | 'formReview' | '';
  propertyId: string;
  address: string;
  unitNumber: string;
  rentAmount: string;
  leaseDocument: string;
  landlordType: string;
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  interacMail: string;
  tenant: {
    account?: {
      id: string;
      type: string;
      email: string;
    };
    landlord?: {
      id: string;
      firstName: string;
      lastName: string;
      phone: string;
      email: string;
    };
    property?: {
      id: string;
      rentalAddress: string;
    };
    id?: string;
    unit?: string | number;
  };
  phone: string;
  status: string;
  landlordName: string;
  landlordEmail: string;
  landlordModeOfPayment: string;
}

interface IRentPaymentSlice {
  refetchGetUserRentPayment: boolean;
  isShowRentPaymentModal: boolean;
  activeRentPaymentModal:
    | 'rentPayPreviewModal'
    | 'rentPaymentOptionModal'
    | 'paymentProcessModal'
    | 'responseModal'
    | 'rentPaymentPreviewModal'
    | 'rentPaymentPhoneVerifyModal'
    | 'rentPaymentSelfieModal'
    | '';
  rentPaymentData: any;
  rentReviewPayload: IRentReviewPayload;
  rentPaymentApiResponse: any;
  rentPaymentApiData: any;
  rentPaymentPreviewData: any;
}

const initialState: IRentPaymentSlice = {
  refetchGetUserRentPayment: false,
  isShowRentPaymentModal: false,
  activeRentPaymentModal: '',
  rentPaymentData: {},
  rentReviewPayload: {
    id: '',
    modalType: '',
    propertyId: '',
    landlordName: '',
    address: '',
    unitNumber: '',
    rentAmount: '',
    leaseDocument: '',
    landlordType: '',
    company: '',
    firstName: '',
    lastName: '',
    tenant: {},
    email: '',
    interacMail: '',
    phone: '',
    status: '',
    landlordEmail: '',
    landlordModeOfPayment: ''
  },
  rentPaymentApiResponse: null,
  rentPaymentApiData: null,
  rentPaymentPreviewData: null
};

export const rentPaymentSlice = createSlice({
  name: 'rentPayment',
  initialState,
  reducers: {
    setRefetchGetUserRentPayment: (state: IRentPaymentSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.refetchGetUserRentPayment = payload;
    },
    setIsShowRentPaymentModal: (state: IRentPaymentSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isShowRentPaymentModal = payload;
    },
    setActiveRentPaymentModal: (
      state: IRentPaymentSlice,
      action: PayloadAction<
        | 'rentPayPreviewModal'
        | 'rentPaymentOptionModal'
        | 'paymentProcessModal'
        | 'responseModal'
        | 'rentPaymentPreviewModal'
        | 'rentPaymentPhoneVerifyModal'
        | 'rentPaymentSelfieModal'
        | ''
      >
    ) => {
      const { payload } = action;
      state.activeRentPaymentModal = payload;
    },
    setRentPaymentData: (state: IRentPaymentSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.rentPaymentData = payload;
    },
    setRentReviewPayload: (state: IRentPaymentSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.rentReviewPayload = payload;
    },
    setRentPaymentPreviewData: (
      state: IRentPaymentSlice,
      action: PayloadAction<IRentPaymentData>
    ) => {
      const { payload } = action;
      state.rentPaymentPreviewData = payload;
    },
    setRentPaymentApiData: (state: IRentPaymentSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.rentPaymentApiData = payload;
    },
    setRentPaymentApiResponse: (state: IRentPaymentSlice, action: PayloadAction<any>) => {
      const { payload } = action;
      state.rentPaymentApiResponse = payload;
    }
  }
});

const { actions, reducer } = rentPaymentSlice;

export const {
  setRefetchGetUserRentPayment,
  setIsShowRentPaymentModal,
  setActiveRentPaymentModal,
  setRentPaymentData,
  setRentReviewPayload,
  setRentPaymentApiResponse,
  setRentPaymentPreviewData,
  setRentPaymentApiData
} = actions;

export default reducer;
